import { useState, useEffect, useRef } from "react";
export default function JobCategoriesSelector({ tags = [], onChange }) {
    const [searchTerm, setSearchTerm] = useState("");
    const [selectedTags, setSelectedTags] = useState([]);
    const [showDropdown, setShowDropdown] = useState(false);
    const wrapperRef = useRef(null);

    const filteredTags = tags.filter(
        (t) =>
            t.toLowerCase().includes(searchTerm.toLowerCase()) &&
            !selectedTags.includes(t)
    );

    const addTag = (tag) => {
        if (!tag || tag.trim() === "") return;
        const formatted = tag.trim();
        if (!selectedTags.includes(formatted)) {
            const updated = [...selectedTags, formatted];
            setSelectedTags(updated);
            if (onChange) onChange(updated);
        }
        setSearchTerm("");
        setShowDropdown(false);
    };

    const handleSelect = (tag) => addTag(tag);

    const removeTag = (tag) => {
        const updated = selectedTags.filter((t) => t !== tag);
        setSelectedTags(updated);
        if (onChange) onChange(updated);
    };

    const handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
            addTag(searchTerm);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (wrapperRef.current && !wrapperRef.current.contains(event.target)) {
                setShowDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () =>
            document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <div className="search-container" id="MarginSearch" ref={wrapperRef}>
            <div className="selected-tags">
                {selectedTags.map((tag) => (
                    <span key={tag} className="tag-chip" onClick={() => removeTag(tag)}>
                        {tag}
                    </span>
                ))}
                <input
                    id="categories"
                    className="searchInput"
                    type="text"
                    placeholder="Type here"
                    value={searchTerm}
                    onChange={(e) => {
                        setSearchTerm(e.target.value);
                        setShowDropdown(true);
                    }}
                    onKeyDown={handleKeyDown}
                />
            </div>

            {showDropdown && filteredTags.length > 0 && (
                <div className="search-dropdown">
                    {filteredTags.map((tag) => (
                        <div
                            key={tag}
                            className="dropdown-items"
                            onClick={() => handleSelect(tag)}
                        >
                            {tag}
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
}
